<template>
    <p class="text-md" :class="config.ui" v-html="sanitizedText"></p>
</template>

<script setup lang="ts">
import type { TextBlockConfig } from '~~/layers/base/types/blockConfigs'
import { sanitizeHtml } from '@/utils/sanitizeHtml'

const props = defineProps<{
    config: TextBlockConfig
}>()

const sanitizedText = computed(() => sanitizeHtml(props.config.text))
</script>
